import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "className", "name", "icon", "checked", "onChange", "disabled"];
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import { Text } from "../../Text";
import { getColor } from "./utils";
import styles from "./styles.pcss";
var cnSegmentedControlItem = cnBem('segmented-control-item', styles);
export var SegmentedControlItem = /*#__PURE__*/forwardRef(function (props, ref) {
  var label = props.label,
    className = props.className,
    name = props.name,
    Icon = props.icon,
    checked = props.checked,
    onChange = props.onChange,
    disabled = props.disabled,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("label", _extends({}, otherProps, {
    className: cnSegmentedControlItem({
      disabled: disabled,
      interactive: !!onChange
    }, [className]),
    ref: ref,
    tabIndex: disabled ? -1 : 1,
    "data-t-id": "SegmentedControl-SegmentedControlItem"
  }), /*#__PURE__*/React.createElement("input", {
    checked: checked,
    className: cnSegmentedControlItem('input'),
    disabled: disabled,
    name: name,
    onChange: onChange,
    type: "radio"
  }), Icon ? /*#__PURE__*/React.createElement(Icon, {
    className: cnSegmentedControlItem('icon'),
    color: getColor(disabled, checked),
    size: 24
  }) : /*#__PURE__*/React.createElement(Text, {
    className: cnSegmentedControlItem('label'),
    color: getColor(disabled, checked),
    size: "xs"
  }, label));
});